import React from 'react'
import { Detail } from './DetailBlock'

export default class DetailHeader extends React.Component {
  render() {
    const {
      name,
      entityType = 'Domestic Limited Liability Company',
      status,
      statusColor = 'green',
      systemId,
      filingDate,
      filingDateLabel,
      standingBlock,
      systemIdLabel,
      children,
    } = this.props
    return (
      <div className="row detail-header">
        <div
          className={`${standingBlock === false ? 'col' : 'col-lg-10 col-md-9 col-sm-8 first-col'}`}
        >
          <div className="critical-block">
            <div className="name-block">
              <h2 className="name">{name}</h2>
              <span className="type">{entityType}</span>
            </div>
            <div className={`details-block status-color-${statusColor}`}>
              {status && <Detail label="Status" value={status} />}
              <Detail label={systemIdLabel || 'System ID'} value={systemId} />
              {filingDate ? (
                <Detail label={filingDateLabel || 'Initial Filing Date'} value={filingDate} />
              ) : null}
              {children}
            </div>
          </div>
        </div>
        {standingBlock !== false && (
          <div className="col-lg-2 col-md-3 col-sm-4 last-col">
            <div className="standing-block">
              <Standing label="Standing" standing="Good" color="green" />
              <Standing label="Standing-RA" standing="Delinquent" color="red" />
              <Standing label="Other" standing="Good" color="green" />
            </div>
          </div>
        )}
      </div>
    )
  }
}

const Standing = ({ standing, label, color = '' }) => (
  <div className={`standing standing-${color}`}>
    <Detail label={label} value={standing} />
  </div>
)
